export default "__VITE_ASSET__CBiZiL_E__"